import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TimeOfDayInterface } from '@vendasta/listing-products';

import { UntypedFormControl } from '@angular/forms';
import { TimePicker } from '../../../time-picker/time-picker.component';
import { convertToTimeOfDay } from '../../business-hours';
import { SpecialHoursTimeSpanInterface } from '../../special-hours/business-hours.interface';

@Component({
  selector: 'forms-edit-time-span',
  templateUrl: './edit-time-span.component.html',
  styleUrls: ['./edit-time-span.component.scss'],
  standalone: false,
})
export class EditTimeSpanComponent implements OnInit {
  @Input() allowDelete = false;
  @Output() deleted = new EventEmitter();

  startTime: UntypedFormControl = new UntypedFormControl();
  endTime: UntypedFormControl = new UntypedFormControl();
  private hour: SpecialHoursTimeSpanInterface;
  errorMessage = '';

  @Input() get value(): SpecialHoursTimeSpanInterface {
    this.valueChange.emit(this.hour);
    return this.hour;
  }
  set value(val: SpecialHoursTimeSpanInterface) {
    this.hour = val;
  }

  @Output() valueChange: EventEmitter<SpecialHoursTimeSpanInterface> = new EventEmitter();

  get allDay(): boolean {
    return this.startTime.value === TimePicker.ALL_DAY;
  }

  get notesOnly(): boolean {
    return this.startTime.value === TimePicker.NOTES_ONLY;
  }

  ngOnInit(): void {
    this.startTime.setValue((this.hour?.startTime?.hours || 9) + ':' + (this.hour?.startTime?.minutes || 0));
    this.endTime.setValue((this.hour?.endTime?.hours || 10) + ':' + (this.hour?.endTime?.minutes || 0));

    this.startTime.valueChanges.subscribe((val) => {
      if (val === TimePicker.ALL_DAY) {
        this.value.startTime = { hours: 0, minutes: 0 } as TimeOfDayInterface;
        this.value.endTime = { hours: 0, minutes: 0 } as TimeOfDayInterface;
      } else {
        this.value.startTime = convertToTimeOfDay(val);
      }
    });

    this.endTime.valueChanges.subscribe((val) => {
      this.value.endTime = convertToTimeOfDay(val);
    });
  }

  deleteCallback(): void {
    this.deleted.emit();
  }
}
